import * as simulatorServices from "../../../services/SimulatorsServices";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { salvarSimulacao, enviarAprovacao, consultarBeneficioFiscal } from "./SimulatorsServices";
import useCacheMutation from "~hooks/useCacheMutation";

export const useGetSimulators = () => {
  const { data, loading, error } = useQuery(["simulations"], simulatorServices.getSimulations);

  return { data, loading, error };
};

export const useGetClients = () => {
  const { data, loading, error } = useQuery(["clients"], simulatorServices.getClients);

  return { data, loading, error };
};

export const useGetClientById = (idClient) => {
  const { data, loading, error } = useQuery(["clients"], () => simulatorServices.getClients(idClient), {
    onSuccess: (data) => {
    },
  });

  return { data, loading, error };
};


export const useGetProductsFromSimulation = (simulationId) => {
  const { data, isLoading, error } = useQuery(["produtos", simulationId], () =>
    simulatorServices.getProdutcsFromSimulation(simulationId)
  );

  return { data, isLoading, error };
};

export const useGetSimulationsByClient = (idCliente) => {
  const { data, isLoading, error } = useQuery(["simulacoes", idCliente], () =>
    simulatorServices.getSimulationsByClient(idCliente)
  );

  return { data, isLoading, error };
};

export const useSalvarSimulacao = (simulacao, onSuccessCloseModal, onErrorCloseModal) => {
  const { mutateCached } = useCacheMutation(
    salvarSimulacao,
    "Salvar Simulação",
    null,
    null,
    null,
    onSuccessCloseModal,
    onErrorCloseModal
  );

  const handleSave = () => {
    mutateCached(simulacao);
  };

  return handleSave;
};

export const useEnviarAprovacao = (simulacaoAprovacao, onSuccessCloseModal, onErrorCloseModal) => {
  const { mutateCached } = useCacheMutation(
    enviarAprovacao,
    "Enviar Aprovacao",
    null,
    null,
    'Enviado para o portal de aprovações',
    onSuccessCloseModal,
    onErrorCloseModal
  );

  const handleSave = () => {
    mutateCached(simulacaoAprovacao);
  };

  return handleSave;
};

export const useGetBeneficioFiscal = (simulacaoId, beneficioEnabled) => {
  const res = useQuery(["beneficio-fiscal"], () => consultarBeneficioFiscal(simulacaoId), {
    enabled: beneficioEnabled,
  });

  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["beneficio-fiscal"]);
  };

  return { ...res, clearCache };
}


export const useGetPrecoRegra = (precosRegraEnabled, skip, take, dataAtualizacao) => {
  const res = useQuery(["preco-regra"], () => simulatorServices.getPrecosRegra(skip, take, dataAtualizacao), {
    enabled: precosRegraEnabled,
  });

  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["preco-cliente"]);
  };

  return { ...res, clearCache };
}

export const useGetPrecoCliente = (precosRegraEnabled, skip, take, dataAtualizacao) => {
  const res = useQuery(["preco-cliente"], () => simulatorServices.getPrecosCliente(skip, take, dataAtualizacao), {
    enabled: precosRegraEnabled,
  });

  const queryClient = useQueryClient();

  const clearCache = () => {
    queryClient.removeQueries(["preco-cliente"]);
  };

  return { ...res, clearCache };
}

export const useGetNegociacoesPrecoRegra = (negociacoesPrecoRegraEnabled) => {
  const { data, loading, error } = useQuery(["negociacoes-preco-regra"], simulatorServices.getNegociacoesPrecosRegra, {
    enabled: negociacoesPrecoRegraEnabled,
  });

  return { data, loading, error };
}

export const useGetSimuladorSolicitacoes = (simuladorSolicitacoesEnabled) => {
  const { data, loading, error, isLoading } = useQuery(["simulador-solicitacoes"], simulatorServices.getSimuladorSolicitacoes, {
    enabled: simuladorSolicitacoesEnabled,
    staleTime: 1000
  });

  return { data, loading: isLoading, error, isLoading };
}



export const useSalvarRenovacao = (campos, onSuccessCloseModal, onErrorCloseModal) => {
  const { mutateCached } = useCacheMutation(
    simulatorServices.salvarRenovacao,
    "Renovacões Tabela de Preço Cliente",
    onSuccessCloseModal,
    onErrorCloseModal,
    "Verifique o status na aba de solicitações"
  );

  const handleSave = () => {
    mutateCached(campos);
  };

  return handleSave;
};
